<template>
    <section class="esesja-logo">
        <img :src="$appConfig.logo.path" :alt="$appConfig.logo.alt" />
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "eSesjaLogo"
    }
</script>
<style lang="scss">
    .esesja-logo {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 157px;
            height: 47px;
        }
    }
</style>